import { forwardRef } from "react";

import type { BaseTriggerProps } from "./types";

const BaseTrigger = forwardRef<HTMLButtonElement, BaseTriggerProps>(
  ({ type = "button", children, ...props }, ref) => {
    return (
      <button ref={ref} type={type} {...props}>
        {children}
      </button>
    );
  },
);

BaseTrigger.displayName = "BaseTrigger";

export default BaseTrigger;
